import React from 'react';
import AwardsContent from './AwardsContent';
import BreadCrumbNav from './BreadCrumbNav';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import PreLoader from './PreLoader';

const Awards = () => {

  return (
    <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Awards" />

        <AwardsContent />

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default Awards;